import { render, staticRenderFns } from "./bankacc.vue?vue&type=template&id=b02f8304&scoped=true&"
import script from "./bankacc.vue?vue&type=script&lang=js&"
export * from "./bankacc.vue?vue&type=script&lang=js&"
import style0 from "./bankacc.vue?vue&type=style&index=0&id=b02f8304&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b02f8304",
  null
  
)

export default component.exports